/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit, ViewChild} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {URLSearchParams, HttpModule} from '@angular/http';
import {NgModule} from '@angular/core';
import {TabViewModule, PanelModule, DataTableModule, SharedModule,PaginatorModule,DropdownModule,InputTextModule,CalendarModule} from 'primeng/primeng';
import {SelectItem} from 'primeng/primeng';
import {MamAdminService} from '../../service/mam_service.component';
import {AgentLog} from '../../model/agentlog';
import {ControlLog} from '../../model/controllog';
import {FormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {BrowserModule} from "@angular/platform-browser";
import {TranslateServiceForm} from "../../translate/translate.service";
import {SearchDropBoxModule} from "../../component/search_dropbox.component";
import {Logger, Options, Level } from "angular2-logger/core";
import {MainPipeMoudle} from "../../pipe/main.pipe";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe";
import { CookieService } from 'angular2-cookie/core';
import {Paginator} from "primeng/components/paginator/paginator";


@Component({
  selector: 'log',
  // host : {'(document:keydown)' : 'onKeyUp($event)'},
  templateUrl: 'log.html'
})
export class LogComponent implements OnInit {
  @ViewChild('pagin') pagin : Paginator;
  // @HostListener('window:keyup', ['$event'])
  // onKeyup(event: any) {
  //   console.log('keyup..', event);
  // }
  activeTabNumber: any;
  agentlog_list: AgentLog[] = [];
  controllog_list : ControlLog[] = [];
  page: number;
  max: number;
  agentlog_list2: AgentLog[] = [];

  selectedAgentLogList: AgentLog;
  search: string;
  field: string;
  start: string;
  end: string;
  searchIDs: SelectItem[];
  levels: SelectItem[];
  logTypes: SelectItem[];
  selectedSearchID: string;
  searchText: string;

  totalRecord: number;
  sDate: string;
  eDate: string;

  dateIsTrue : boolean = true;
  searchIsTrue : boolean = false;
  pageMax : number=10;
  date : Date= new Date();
  datePipe : any = new DatePipe("en");

  isLike : string;
  private translate:TranslateServiceForm;

  isHiddenAgentLog : boolean = false;
  isHiddenControlLog : boolean = true;



  searchId : string;


  searchOsTypeDropBox : SelectItem[];
  searchTextDropBox : SelectItem[];
  searchTextIsDropBox : boolean;
  searchTextIsUse : boolean;
  excelIsTrue : boolean = true;

  log_type_items : SelectItem[];
  controllog_type_items : SelectItem[];
  osTypeValue : number;

  companyId : any;


  constructor(private service: MamAdminService, private _translate: TranslateServiceForm, private logger : Logger , private cookie : CookieService) {
    this.translate = _translate;
    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 'all'});
    this.searchIDs.push({label: this.translate.instant('LANG_UserName'), value: 'username'});
    this.searchIDs.push({label: this.translate.instant('LANG_sourceDevice'), value: 'deviceName'});
    this.searchIDs.push({label: this.translate.instant('LANG_logType'), value: 'name'});

    this.searchOsTypeDropBox = [];
    this.searchOsTypeDropBox.push({label: 'Android', value: 0});
    this.searchOsTypeDropBox.push({label: 'ios', value: 1});

    this.companyId = cookie.get('companyId');
  }

  ngOnInit() {
    this.activeTabNumber = 0;
    this.page = 1;
    this.max = 10;
    this.levels = [];
    this.osTypeValue = 0;

    this.getAgentLogGroupName();

    let nDate = new Date();
    nDate.setDate(nDate.getDate()-15);
    this.sDate = this.datePipe.transform(nDate, 'yyyy-MM-dd')
    this.eDate = this.datePipe.transform(this.date, 'yyyy-MM-dd')
    this.getAgentLogSearch(0,10, "", "", this.sDate, this.eDate);
    this.getAgentLogGroupName();
    this.getControlLogGroupName();
  }


  excelExport(event){
    this.logger.debug(event);
    this.logger.debug(this.sDate);
    this.logger.debug(this.eDate);
    if(!this.sDate || !this.eDate) {
      alert(this.translate.instant('MESSAGE_Search_And_Out'));
      return;
    }
    //var url = this.service.getUrl() + "/mgr/log/agentlog/excel";
    var url = "";
    if(this.osTypeValue == 0){
      url =this.service.getUrl() + "/mgr/log/agentlog/excel";
    } else {
      url = this.service.getUrl() + "/mgr/log/control/ios/excel";
    }
    this.logger.debug(this.searchId);

    if(!this.searchId || this.searchId == "all") {
      url = url + "?start=" + this.sDate + "&end=" + this.eDate + "&companyId=" + this.companyId;
    } else{
      url = url + "?start=" + this.sDate + "&end=" + this.eDate +
      "&search_text=" + this.searchText + "&search_field=" + this.searchId + "&companyId=" + this.companyId;
    }
    window.open(url);
  }

  // onKeyUp(event) {
  //   console.log("agent log onKeyDown :" , event);
  // }

  getSearchModel(event) {
    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.sDate = event.sDate;
    this.eDate = event.eDate;
    this.selectedSearchID = event.searchId;

    if(!this.sDate || !this.eDate ) {
      alert(this.translate.instant('MESSAGE_SearchDate_Require'));
      return;
    }

    if(this.eDate < this.sDate ) {
      alert(this.translate.instant('MESSAGE_LastDate_Less_StartDate'));
      return;
    }

    if(this.selectedSearchID == 'name' && !this.searchText) {
      alert(this.translate.instant('MESSAGE_Select_LogType'));
      return;
    }
    //this.getAgentLogSearch(0, this.pageMax, this.searchText, this.selectedSearchID, this.sDate, this.eDate);
    if(this.osTypeValue == 0) this.getAgentLogSearch(0, this.pageMax, this.searchText, this.selectedSearchID, this.sDate, this.eDate);
    else this.getControlLogSearch(0, this.pageMax, this.searchText, this.selectedSearchID, this.sDate, this.eDate);
  }

  paginate(event) {
    this.pageMax = event.rows;
    if (this.searchIsTrue) {
      //this.getAgentLogSearch(event.page, event.rows ,this.searchText, this.selectedSearchID, this.sDate , this.eDate);
      if(this.osTypeValue == 0) this.getAgentLogSearch(event.page, event.rows ,this.searchText, this.selectedSearchID, this.sDate , this.eDate);
      else this.getControlLogSearch(event.page, event.rows, this.searchText, this.selectedSearchID, this.sDate, this.eDate);
    } else {
      //this.getAgentLogSearch(event.page, event.rows, '', '', this.sDate, this.eDate);
      if(this.osTypeValue == 0) this.getAgentLogSearch(event.page, event.rows, '', '', this.sDate, this.eDate);
      else this.getControlLogSearch(event.page, event.rows, '','',this.sDate, this.eDate);
    }
  }

  searchTextChange(data) {
    this.logger.debug("data => ", data);
    if(data == "name") {
      //this.searchTextIsDropBox = true;
      if(this.osTypeValue == 0) {
        this.searchTextDropBox = this.log_type_items;
        this.log_type_items;
      } else {
        this.searchTextDropBox = this.controllog_type_items;
      }
      this.searchTextDropBox = this.log_type_items;
      this.searchTextIsUse = false;
    } else if(data == 'all' || !data)  {
      this.searchTextIsDropBox = false;
      this.searchTextIsUse = false;
    } else {
      this.searchTextIsDropBox = false;
      this.searchTextIsUse = true;
    }

  }
  
  osTypeChangeAction(data) {
    
    this.osTypeValue = data;
    console.log(this.sDate);
    // ios 
    if(data == 1) {
      if(this.pagin){
        this.pagin.first=0;
      }
      this.getControlLogSearch(0,10, '','',this.sDate,this.eDate);
      this.isHiddenAgentLog = true;
      this.isHiddenControlLog = false;
    } 
    // android
    else {
      if(this.pagin){
        this.pagin.first=0;
      }
      this.getAgentLogSearch(0,10, '','',this.sDate,this.eDate);
      this.isHiddenControlLog = true;
      this.isHiddenAgentLog = false;


    }
    
  }

  getControlLogSearch(page: number, max: number, search: string, field: string, start: string, end: string) : void {
    this.service.getControlLogForDeviceForIOS(page, max, search, field, start, end).subscribe(
      value => {
        this.controllog_list = value.content;
        this.totalRecord = value.totalElements;
        if(this.controllog_list && this.controllog_list.length>0) {
          this.controllog_list.forEach(log =>{
            var transLog = this.translate.instant(log.name);
            if(transLog != 'NONE') {
              log.name = transLog;
            } 
        });

        }
        
      },
      error => {this.logger.error("-- error : " + error);},
      () => { })
  }

  getAgentLogSearch(page: number, max: number, search: string, field: string, start: string, end: string): void {
    this.service.getAgentLogSearch(page, max, search, field, start, end, this.companyId).subscribe(
      value => {
        this.agentlog_list = value.content;
        this.totalRecord = value.totalElements;
        this.logger.debug("-- agent log list : ", value);
        if(this.agentlog_list && this.agentlog_list.length>0) {
          this.agentlog_list.forEach(log =>{
            log.name = this.translate.instant(log.name);
            let message = log.message;
            let div;
            try {
              if(message && message.length >= 3) {
                var preWord = message.substring(0,3);
                if(preWord == '|||') {
                  message = message.substring(3);
                  div = message.split("||");
                } else {
                  div = message.split(":");
                }

                if(div.length > 1) {
                  var convertedMsg = div[0] + " : ";
                  var tokens = div[1].split("^");
                  var policyName = tokens[0].split(",");
  					      var policyValue = tokens[1].split(",");
                  //this.logger.debug("policyValue :", policyValue);
                  for(var j=0 ; j < policyName.length ; j++) {
                    convertedMsg += ((window[policyName[j]] === undefined)? this.translate.instant(policyName[j]) : window[policyName[j]]);
                    convertedMsg += "(" + policyValue[j] + ")";
                  }
                  log.message = convertedMsg.substring(0, convertedMsg.length);

                }
              }
            } catch(e) {
              this.logger.error("error catch :", e)
            }
          })

        }

      },
      error => {this.logger.error("-- error : " + error);},
      () => { })
  }

  getAgentLogGroupName() {
    this.service.getAgentLogGroupName().subscribe(
      value => {
        this.logger.debug(value);
        this.log_type_items = [];
        this.log_type_items.push({label: "---------------------", value: "all"});
        for(var i = 0 ; i< value.length ; i++){
          if(value[i] == 'AL_appInstall' || value[i] == 'AL_appRemove' || value[i] == 'AL_adminAcquire') continue;
          this.log_type_items.push({label: this.translate.instant(value[i]), value: value[i]});
        }
      },
      error => {this.logger.error("-- error : " + error);},
      () => {})
  }
  
  getControlLogGroupName() {
    this.service.getControlLogGroupName().subscribe(
      value => {
        console.log("getControlLogGroupName value -----> " , value)
        this.logger.debug(value);
        this.controllog_type_items = [];
        this.controllog_type_items.push({label: "---------------------", value: "all"});
        if(value && value.length>0){
          for(var i = 0 ; i< value.length ; i++){
            if(value[i] == 'APP_INSTALL' || value[i] == 'APP_REMOVE' || value[i] == 'AL_TAToken_Expired' || value[i] == 'AL_TAToken_ISSUE' ) continue;

            var transMessage = this.translate.instant(value[i]);
            if(transMessage == 'NONE') {
              transMessage = value[i];
            }
            
            this.controllog_type_items.push({label: transMessage, value: value[i]});
          }
        }
      },
      error => {this.logger.error("-- error : " + error);},
      () => {})
  }

  keyup()  {
    alert("asdasdasd");
  }

}
@NgModule({
  imports: [PanelModule, TabViewModule, DataTableModule, SharedModule, CommonModule,PaginatorModule,DropdownModule,InputTextModule,BrowserModule,HttpModule, RouterModule,FormsModule,CalendarModule, SearchDropBoxModule, MainPipeMoudle, TranslatePipeMoudle],
  exports: [LogComponent],
  declarations: [LogComponent],
  providers: [],
})
export class LogModule {
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/log/log.ts